import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint, duration, easing } from '@twistopayments/design-system/styles';

export type Sizes = keyof typeof sizes;

export const inputWrapper = (theme: Theme) => css`
  padding: 0;
  box-shadow: none;
  position: relative;

  ${breakpoint.up('md')} {
    padding: ${theme.spacing[0]};
  }
`;

export const input = (theme: Theme) => css`
  background-color: ${theme.palette.tertiary.lowContrast};
  border-radius: ${theme.borderRadius.sm};
  transition: background-color ${duration.standard}ms ${easing.easeInOut};

  &:not([disabled]):focus {
    box-shadow: 0px 1px 0px 0px ${theme.palette.secondary.mainContrast};
  }

  &:not([disabled]):hover,
  &:not([disabled]):focus {
    background-color: ${theme.palette.tertiary.mediumContrast};
  }

  &::placeholder {
    color: ${theme.palette.tertiary.main};
  }
`;

export const sizes = {
  small: (theme: Theme) => css`
    padding: ${theme.spacing[8]};
    padding-left: ${theme.spacing[56]};
  `,
  medium: (theme: Theme) => css`
    padding: ${theme.spacing[12]};
    padding-left: ${theme.spacing[56]};
  `,
  large: (theme: Theme) => css`
    padding: ${theme.spacing[16]};
    padding-left: ${theme.spacing[56]};
  `,
};

export const disabledInput = (theme: Theme) => css`
  &::placeholder,
  &.empty {
    color: ${theme.palette.disabled.accent};
  }
`;

export const inputIcon = (theme: Theme, barSize: Sizes) => css`
  left: ${theme.spacing[20]};
  color: ${theme.palette.tertiary.upperMediumContrast};
  font-size: ${barSize === 'small' ? theme.spacing[20] : theme.spacing[24]};
  margin-right: ${theme.spacing[12]};
  position: absolute;
  pointer-events: none;
`;

export const disabledInputIcon = (theme: Theme) => css`
  color: ${theme.palette.disabled.accent};
`;

export const endAdornment = (theme: Theme) => css`
  right: ${theme.spacing[16]};
  position: absolute;
`;
